export function getHomeRoute() {
    return '/';
}

export function getGamePageRoute() {
    return '/game';
}

export function getRulesRoute() {
    return '/rules';
}

export function getPolicyRoute() {
    return '/polityka-prywatnosci';
}

export function getAccessibilityRoute() {
    return '/dostepnosc';
}
export function getEntryRoute() {
    return '/wstep';
}